import TextField from "@mui/material/TextField";
import { Controller } from "react-hook-form"
import InputAdornment from '@mui/material/InputAdornment';

const MpgInput = ({ rhfFormInstance, name, className, label, fullWidth, variant, size, placeholder, sx, disabled, required, onExtraOnchangeHandler, multiline, rows, width, endAdornmentComponent, startAdornmentComponent }) => {

    const { control, formState } = rhfFormInstance

    const myStyle = {
        // maxWidth: !!fullWidth ? fullWidth : '225px',
        width: !!fullWidth ? fullWidth : !!width ? width : '225px',
        '& .MuiInputBase-root.Mui-disabled': {
            backgroundColor: '#f5f5f5',
        },
    }

    return (
        <Controller
            id={`${name}-mpg-input`}
            control={control}
            name={name}
            defaultValue={''}
            render={({
                field: { onChange, onBlur, value, name, ref },
                fieldState: { invalid, isTouched, isDirty, error },
                formState: { errors },
            }) => {
                return (
                    <TextField
                        id={`${name}-mpg-input`}
                        className={!!className ? className : ''}

                        name={`${name}`}
                        onChange={(e) => {
                            onChange(e)

                            if (!!onExtraOnchangeHandler) {
                                onExtraOnchangeHandler(e)
                            }
                        }}

                        value={value}
                        inputRef={ref}

                        fullWidth={!!fullWidth ? fullWidth : false}

                        label={label}
                        variant={!!variant ? variant : "outlined"}
                        size={!!size ? size : "large"}
                        sx={[myStyle, sx]}
                        placeholder={placeholder}
                        disabled={disabled}
                        required={required}
                        margin="normal"

                        multiline={!!multiline}
                        rows={rows}

                        InputLabelProps={{
                            shrink: true,
                        }}

                        InputProps={{
                            startAdornment: <InputAdornment position="start">
                                {
                                    startAdornmentComponent
                                }
                            </InputAdornment>,
                            endAdornment: <InputAdornment position="end">
                                {
                                    endAdornmentComponent
                                }
                            </InputAdornment>,
                        }}

                        error={!!errors[name]}
                        helperText={errors[name] ? errors[name].message : null}
                    />
                )
            }}
        />
    )
}
export default MpgInput